import { render, staticRenderFns } from "./WList.vue?vue&type=template&id=4d1eb9bc&scoped=true&lang=pug&"
import script from "./WList.vue?vue&type=script&lang=js&"
export * from "./WList.vue?vue&type=script&lang=js&"
import style0 from "./WList.vue?vue&type=style&index=0&id=4d1eb9bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1eb9bc",
  null
  
)

export default component.exports